import React from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import ContactPage from './section-components/contact-page';
import Footer from './global-components/footer-v2';
import {Helmet} from "react-helmet";

const Contact = () => {
    return <div>
        <Navbar />
        <Helmet>
            <title>Contact us For more Enquires | MIET Education</title>
            <meta name="description" content="MIET in Chennai offers top training and coaching for all levels of education. Provides customized syllabus and training for students. Call us to know more." />
        </Helmet>
        <PageHeader headertitle="Contact"  />
        <ContactPage />
        <Footer />
    </div>
}

export default Contact

